const RENDER_ORDERS = {
  floor: 0,
  wall: 2,
  door: 3,
  passage: 3,
  window: 3,
  product: 3,
  lengthIndicator: 1,
  angleIndicator: 4,
  roundedBox: 5,
  roomDetailsIndicator: 6,
  texts: 6,
  outline: 1000,
  hotspot: 9999,
  debugObjects: 1001,
};

export default RENDER_ORDERS;
